<template>
  <div id="recieveables-report" class="wrrapper">
    <page-heading title="Recieveables Report">
      <template #content>
        <div class="flex align-center no-print">
          <DateRangePicker @update="updateDate" />
          <Select
            class="mr-1"
            placeholder="Filter By Type/Company"
            :loading="loading"
            :options="sortOptions"
            :input="handleFilters"
          />
          <Select
            v-if="isAdmin"
            class="mr-2"
            styles="expenses-select"
            placeholder="Filter by Branch"
            :input="handleBranchChange"
            :options="brachData"
          />
          <ExportButtons @pdf="handleExportPdf" @excel="handleExportExcel" />
        </div>
      </template>
    </page-heading>
    <div style="height: 100vh;" id="print-report">
      <data-table
        :loading="loading"
        :cols="columns"
        :rows="recieveablesReport"
        height=""
      >
      </data-table>
      <div id="">
        <div class="flex justify-end mr-4 mb-2" style="margin-right: 21rem;">
          <div>
            <div class="percent flex" style="justify-content: space-between;">
              <h2 class="net-total">Total</h2>
              <h2>PKR {{ totalAmount }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapActions, mapGetters } from "vuex";
import { formatedDate, getBranchLogo } from "@/utils/helpers";
import DateRangePicker from "@/components/DateRangePIcker";
import Select from "@/components/Select";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";

export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    ExportButtons
  },
  data() {
    return {
      filters: {
        start_date: formatedDate(),
        end_date: formatedDate(),
        isOther: this.isOther,
        branchId: null
      },
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "patient",
          label: "Patient Name",
          sortable: true,
          link: true,
          routerName: "receivablesReportDetails"
        },
        {
          column: "responsible",
          label: "Guardian name",
          sortable: true
        },
        {
          column: "mr",
          label: "Mr no",
          sortable: true
        },
        {
          column: "amount",
          label: "Balance",
          formatAmount: true,
          sortable: true
        }
      ],
      isAdmin: null,
      brachData: [],
      bussinessLogoUrl: "",
      branchLogoUrl: ""
    };
  },
  methods: {
    ...mapActions("reports", ["recieveablesReportList"]),
    ...mapActions("doctors", ["companyList"]),
    ...mapActions("expenses", ["fetchBranch"]),
    updateDate(val) {
      (this.filters.end_date = formatedDate(val.endDate)),
        (this.filters.start_date = formatedDate(val.startDate));
      this.recieveablesReportList(this.filters);
    },
    exportInput() {
      return {
        title: "Receivables Report",
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        printedBy: this.userInfo.full_name,
        businessLogoUrl: this.bussinessLogoUrl,
        branchLogoUrl: this.branchLogoUrl,
        cols: this.columns,
        rows: this.recieveablesReport,
        summary: [
          { label: "Total", value: "PKR " + this.totalAmount.toLocaleString() }
        ],
        fileName: "receivables-report"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleFilters(val) {
      if (val) {
        this.filters.companyName = val;
        this.recieveablesReportList(this.filters);
      } else {
        delete this.filters.companyName;
        this.recieveablesReportList(this.filters);
      }
    },

    async handleBranchChange(val) {
      if (val && val != null) {
        const object = getBranchLogo(this.fetchUserBranch, val.key);
        this.branchLogoUrl = object;
        this.filters.branchId = val.key;
        await this.recieveablesReportList(this.filters);
      }
      if (val === null) {
        this.recieveablesReportList(this.filters);
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      recieveablesReport: "reports/recieveablesReport",
      companyName: "doctors/companyName",
      role: "auth/role",
      userInfo: "auth/userInfo",
      isOther: "auth/isOther",
      fetchUserBranch: "expenses/fetchUserBranch",
      settings: "bussiness/settings"
    }),
    sortOptions() {
      const arr = [];
      this.companyName.map(item => arr.push(item.name));
      return arr;
    },
    roleId() {
      const { id } = this.role && this.role.find(item => item);
      return id;
    },
    totalAmount() {
      return this.recieveablesReport.reduce(
        (acc, item) => acc + item.amount,
        0
      );
    }
  },
  async mounted() {
    this.isAdmin = this.userInfo.userRole.some(({ name }) => name === "admin");
    await this.fetchBranch();
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });

    this.branchLogoUrl = getBranchLogo(
      this.fetchUserBranch,
      this.userInfo?.userBranchId
    );

    this.bussinessLogoUrl = this.userInfo?.bussinessLogoUrl;

    this.recieveablesReportList(this.filters);
    this.companyList("company");
  }
};
</script>

<style>
.percent {
  margin-bottom: 10px;
}
.percent h2 {
  font-weight: normal;
  margin: 0;
  font-size: var(--fs-body);
  line-height: 30px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: var(--text);
}
.percent .total {
  width: 150px;
  margin-right: 30px;
}
.percent .net-total {
  width: 150px;
  margin-right: 30px;
  font-weight: 600;
  font-size: var(--fs-body);
  color: var(--ink-900);
}
@media print {
  .print-report {
    margin: 0 !important;
  }
  .percent h2 {
    margin: 0;
    font-size: 8pt;
  }
  .percent .net-total {
    margin-right: 10px;
    font-weight: 500;
    font-size: 8pt;
  }
  .percent .total {
    margin-right: 10px;
  }
  .percent {
    margin: 0;
  }
}
</style>
